// libs
import React from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsFontVariants, DlsColorTokens } from '@/constants/DLSTokens';
// helpers
import { formatNumberIntl, prefixWithRupee } from '@/helpers/utils';
// styles
import styles from './ProgressBar.module.scss';
const ProgressBar = ({ max, spent }) => {
    const progress = (Number(spent) / Number(max)) * 100;
    const remaining = Number(max) - Number(spent);
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.remaining },
            React.createElement(Text, { variant: DlsFontVariants.header_H3_Black, color: DlsColorTokens.text_High_Emphasis }, prefixWithRupee(formatNumberIntl({ value: remaining }))),
            React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_High_Emphasis, className: styles.remainingText }, "remaining")),
        React.createElement("div", { className: styles.track },
            React.createElement("div", { style: {
                    width: `${progress < 100 ? progress : 100}%`,
                }, className: styles.progress })),
        React.createElement("div", { className: styles.footer },
            React.createElement("div", { className: styles.footerLeftContent },
                React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_High_Emphasis }, prefixWithRupee(formatNumberIntl({ value: spent }))),
                React.createElement(Text, { variant: DlsFontVariants.body_B3_Med, color: DlsColorTokens.text_Med_Emphasis }, "\u00A0spent so far")),
            React.createElement("div", { className: styles.footerRightContent },
                React.createElement(Text, { variant: DlsFontVariants.body_B2_Med, color: DlsColorTokens.text_High_Emphasis }, prefixWithRupee(formatNumberIntl({ value: max })))))));
};
export default ProgressBar;
